import { render, staticRenderFns } from "./TurnOnAudioModal.vue?vue&type=template&id=4aa7c49c&scoped=true&"
import script from "./TurnOnAudioModal.vue?vue&type=script&lang=js&"
export * from "./TurnOnAudioModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa7c49c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aa7c49c')) {
      api.createRecord('4aa7c49c', component.options)
    } else {
      api.reload('4aa7c49c', component.options)
    }
    module.hot.accept("./TurnOnAudioModal.vue?vue&type=template&id=4aa7c49c&scoped=true&", function () {
      api.rerender('4aa7c49c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/TurnOnAudioModal.vue"
export default component.exports